import "./src/styles/global.css";
import Prism from "prism-react-renderer";
(typeof global !== "undefined" ? global : window).Prism = Prism;

// require("prismjs/components/prism-swift")
// require("prismjs/components/prism-go")
